module.exports = __webpack_public_path__ + "img/neck_width.101a772b.png";